export const sheetMap = {
    medan: '664581388',
    jakarta: '1114522678',
    yogyakarta: '1858067434',
    bandung: '1083742945',
    surabaya: '1590429873',
    makassar: '1791562145',
    denpasar: '1828268349',
  }; 